// extracted by mini-css-extract-plugin
export default {"Paragraph":"hk6nC8S2"};